import React from "react";
import ChartCoin from "./Chart2";
import ChartPoint from "./Chart1";

const Chart = () => {
  return (
    <section className="section_space pb-5  bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <ChartCoin />
          </div>
          <div className="col-lg-6">
            <ChartPoint />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Chart;
